// extracted by mini-css-extract-plugin
module.exports = {"cls1":"index-ButtonToolbar-module--cls1--11ZiD","cls2":"index-ButtonToolbar-module--cls2--3tR4q index-ButtonToolbar-module--cls1--11ZiD"};